import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import axios from 'axios';
import { useAuth } from '../auth/AuthContext';
import {
  Box,
  TextField,
  Button,
  Typography,
  Container,
  Paper,
  MenuItem,
  CircularProgress
} from '@mui/material';

const RegisterTeacher = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const auth = useAuth();
  const schoolId = location.state?.schoolId || auth.schoolId;

  const [formData, setFormData] = useState({
    fullName: '',
    email: '',
    phoneNumber: '',
    subjectSpecialization: '',
    tscNumber: '',
    gender: 'M',
    classRepresenting: ''
  });
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    if (!schoolId) {
      setError('School ID is missing. Please log in again.');
    }
  }, [schoolId]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!schoolId) {
      setError('School ID is missing. Please log in again.');
      return;
    }

    setIsLoading(true);
    setError('');

    try {
      const teacherData = {
        ...formData,
        schoolId
      };

      const response = await axios.post('https://kidsm.vercel.app/api/schools/register-teacher', teacherData);
      if (response.status === 201) {
        alert('Teacher registered successfully!');
        setFormData({
          fullName: '',
          email: '',
          phoneNumber: '',
          subjectSpecialization: '',
          tscNumber: '',
          gender: 'M',
          classRepresenting: ''
        });
      }
    } catch (error) {
      setError(error.response?.data?.message || 'Failed to register teacher. Please try again.');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Container maxWidth="md">
      <Paper elevation={3} sx={{ p: 4, mt: 4 }}>
        <Typography variant="h4" component="h1" gutterBottom align="center">
          Register Teacher
        </Typography>
        
        {error && (
          <Typography color="error" align="center" sx={{ mb: 2 }}>
            {error}
          </Typography>
        )}

        <Box component="form" onSubmit={handleSubmit} sx={{ mt: 2 }}>
          <TextField
            fullWidth
            label="Full Name"
            name="fullName"
            value={formData.fullName}
            onChange={handleChange}
            margin="normal"
            required
          />

          <TextField
            fullWidth
            label="Email Address"
            name="email"
            type="email"
            value={formData.email}
            onChange={handleChange}
            margin="normal"
            required
          />

          <TextField
            fullWidth
            label="Phone Number"
            name="phoneNumber"
            value={formData.phoneNumber}
            onChange={handleChange}
            margin="normal"
            required
          />

          <TextField
            fullWidth
            label="Subject Specialization"
            name="subjectSpecialization"
            value={formData.subjectSpecialization}
            onChange={handleChange}
            margin="normal"
            required
          />

          <TextField
            fullWidth
            label="TSC Number"
            name="tscNumber"
            value={formData.tscNumber}
            onChange={handleChange}
            margin="normal"
            required
          />

          <TextField
            select
            fullWidth
            label="Gender"
            name="gender"
            value={formData.gender}
            onChange={handleChange}
            margin="normal"
            required
          >
            <MenuItem value="M">Male</MenuItem>
            <MenuItem value="F">Female</MenuItem>
          </TextField>

          <TextField
            fullWidth
            label="Class Representing"
            name="classRepresenting"
            value={formData.classRepresenting}
            onChange={handleChange}
            margin="normal"
          />

          <Button
            fullWidth
            variant="contained"
            color="primary"
            type="submit"
            disabled={isLoading}
            sx={{ mt: 3, mb: 2, height: '48px' }}
          >
            {isLoading ? <CircularProgress size={24} color="inherit" /> : 'Register Teacher'}
          </Button>
        </Box>
      </Paper>
    </Container>
  );
};

export default RegisterTeacher;